import React, { useState } from 'react';
import { useApiEffect } from 'framework/hooks/useApiEffect';
import {
	IInventoryItemsQueryParamsForSale,
	inventoryItemsQuery_queryForSale,
	IProductCatalogQueryParamsForSale,
	productCatalogQuery_queryForSale,
} from 'gen/ApiClient';
import { DefaultInventoryItemsQueryParamsForSale } from 'shared/searchAndSelect/DefaultInventoryItemsQueryParamsForSale';
import { SearchContext } from './SearchContext';

const DefaultPcParams: IProductCatalogQueryParamsForSale = {
	searchString: '',
	sortParams: { direction: 'desc', property: 'created' },
	pageParams: { index: 1, size: 10 },
	types: [],
	categories: [],
	subcategories: [],
	hasSerialNumber: undefined,
};

interface IProps {
	children: any;
}

export const SearchProvider = ({ children }: IProps) => {
	const [pcParams, setPcParams] = useState<IProductCatalogQueryParamsForSale>(DefaultPcParams);
	const [pcQueryResult] = useApiEffect(productCatalogQuery_queryForSale, pcParams);
	const [iiParams, setIIParams] = useState<IInventoryItemsQueryParamsForSale>(DefaultInventoryItemsQueryParamsForSale);
	const [iiQueryResult] = useApiEffect(inventoryItemsQuery_queryForSale, iiParams);

	return (
		<SearchContext.Provider
			value={{
				pcParams: pcParams,
				pcQueryResult: pcQueryResult,
				setPcParams: setPcParams,
				iiParams: iiParams,
				iiQueryResult: iiQueryResult,
				setIIParams: setIIParams,
			}}>
			{children}
		</SearchContext.Provider>
	);
};
